import { checkUserPermissions } from '@/services/auth';
import { PERMISSIONS_KEYS } from '@/settings/consts/permissions';

//import ClinicSituations from './screens/index.vue';
const ClinicSituations = () => import('./screens/index.vue')

const clinicSituationsRoutes = [];

if (
  checkUserPermissions([
    PERMISSIONS_KEYS.CLINIC_SITUATIONS_VIEW,
    PERMISSIONS_KEYS.CLINIC_SITUATIONS_INSERT,
    PERMISSIONS_KEYS.CLINIC_SITUATIONS_EDIT,
  ])
) {
    clinicSituationsRoutes.push({
    path: '/situacoes-clinicas',
    name: 'Cadastro / Consulta|Situação Clínica',
    component: ClinicSituations,
    meta: {
      icon: 'fa-sliders-h',
      requiresAuth: true,
    },
  });
}

export { clinicSituationsRoutes };

